<section class="why-nutrigenic">
  <h2 class="ng-title">{{ title }}</h2>
  <p class="ng-subtitle">{{ subtitle }}</p>

  <div class="features-grid">
    <article class="feature-card" *ngFor="let feature of features; trackBy: trackByIcon">
      <img [src]="feature.icon" [alt]="feature.alt" />
      <p>{{ feature.text }}</p>
    </article>
  </div>
</section>
